import { Box, Icon, Paragraph, Table } from '@zillow/constellation-10';
import { IconCircleFilled, IconCircleOutline } from '@zillow/constellation-icons';

type Props = {
  hasInquiry: boolean;
  hasScheduledTour: boolean;
  hasSentApplication: boolean;
};

export default function ProspectStageTableCell({ hasInquiry, hasScheduledTour, hasSentApplication }: Props) {
  const prospectStages = [
    {
      label: 'Inquiry received',
      isStepCompleted: hasInquiry,
    },
    {
      label: 'Tour scheduled',
      isStepCompleted: hasScheduledTour,
    },
    {
      label: 'Application sent',
      isStepCompleted: hasSentApplication,
    },
  ];

  let latestStepCompleted = '';

  return (
    <Table.Cell>
      <Box css={{ display: 'flex', flexDirection: 'row' }}>
        {prospectStages.map(({ isStepCompleted, label }) => {
          if (isStepCompleted) {
            latestStepCompleted = label;
          }

          return (
            <Box
              key={label}
              data-separator="-"
              css={{
                whiteSpace: 'nowrap',
                display: 'flex',
                alignItems: 'center',
                '&:not(:last-child)::after': {
                  content: 'attr(data-separator)',
                },
              }}
            >
              {isStepCompleted ? (
                <Icon size="md" css={{ color: 'green.400' }}>
                  <IconCircleFilled />
                </Icon>
              ) : (
                <Icon size="md" css={{ color: 'icon.subtle' }}>
                  <IconCircleOutline />
                </Icon>
              )}
            </Box>
          );
        })}
      </Box>

      {latestStepCompleted && (
        <Paragraph textStyle="body-xs" css={{ color: 'text.subtle', marginTop: 'tighter', whiteSpace: 'nowrap' }}>
          {latestStepCompleted}
        </Paragraph>
      )}
    </Table.Cell>
  );
}
